import api from './base'
import { objectToQueryString } from '../utils/object'

export default {
  getAll ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/write_offs?${objectToQueryString(filters)}`)
  },
  getById ({ businessUnitId, id, filters }) {
    filters = filters || { includeArticles: true }
    return api().get(`company/business_units/${businessUnitId}/write_offs/${id}?${objectToQueryString(filters)}`)
  },
  save ({ businessUnitId, item }) {
    return api().put(`company/business_units/${businessUnitId}/write_offs`, item)
  },
  saveArticles ({ businessUnitId, writeOffId, item }) {
    return api().put(`company/business_units/${businessUnitId}/write_offs/${writeOffId}/articles`, item)
  },
  delete ({ businessUnitId, id }) {
    return api().delete(`company/business_units/${businessUnitId}/write_offs/${id}`)
  },
  /* articleMargin ({ businessUnitId, id, params }) {
    return api().get(`company/business_units/${businessUnitId}/acceptance_forms/${id}/margin?${objectToQueryString(params)}`)
  }, */
  getPDFList ({ businessUnitId, filters }) {
    return api().get(`company/business_units/${businessUnitId}/write_offs/pdf?${objectToQueryString(filters)}`)
  },
  getPDFSamostojen ({ businessUnitId, writeOffId }) {
    return api().get(`company/business_units/${businessUnitId}/write_offs/${writeOffId}/pdf`)
  }
}
